<auth-header></auth-header>
<form #form="ngForm" (ngSubmit)="onSubmit(form)" novalidate>
    <ui-input>
        <input
            uiInput
            type="email"
            name="email"
            #email="ngModel"
            [(ngModel)]="user.email"
            (ngModelChange)="onHideError()"
            placeholder="Email"
            emailValidator
            maxlength="264"
            required />
        <ui-input-error [input]="email" name="required">Email is required</ui-input-error>
        <ui-input-error [input]="email" name="email">Email is invalid</ui-input-error>
    </ui-input>
    <ui-input>
        <input
            uiInput
            type="password"
            name="password"
            #password="ngModel"
            [(ngModel)]="user.password"
            (ngModelChange)="onHideError()"
            placeholder="Password"
            maxlength="32"
            required />
        <ui-input-error [input]="password" name="required">Password is required</ui-input-error>
    </ui-input>
    <div class="ui-input-error" *ngIf="error" [ngSwitch]="error" [class.visible]="error">
        <span *ngSwitchCase="'invalidGrant'">Invalid email or password</span>
        <span *ngSwitchCase="'userNotActivated'">Check your email to complete registration</span>
        <span *ngSwitchCase="'userIsBlocked'">User was blocked by account administrator</span>
        <span *ngSwitchCase="'userNotExists'">User with this email doesn't exist in the system</span>
    </div>
    <button type="submit" class="default" (click)="validate(form)">Sign in</button>
    <div class="small-letters">
        <p>
            <a routerLink="/password/recover">Forgot password?</a>
        </p>
        <p>
            Don't have an account? <a routerLink="/register">Get started</a>
        </p>
    </div>
    <ui-loading *ngIf="processing"></ui-loading>
</form>
<auth-footer></auth-footer>